import { component$ } from "@builder.io/qwik";
import { Image, type ImageProps } from "@unpic/qwik";

export type CDNImageProps = ImageProps;

export function getCDNImageUrl(src: string, width: number, height?: number) {
  let finalSrc = src;

  // Replace Google Storage URL with form-data subdomain if present
  if (finalSrc.startsWith("https://storage.googleapis.com/dcm-form-data/")) {
    finalSrc = finalSrc.replace(
      "https://storage.googleapis.com/dcm-form-data/",
      "https://form-data.dreamcoachmatch.com/",
    );
  }

  let resizeProps = "";
  if (height) {
    resizeProps = `,height=${height},fit=cover,gravity=auto`;
  }

  // Prepend CDN URL
  return `https://dreamcoachmatch.com/cdn-cgi/image/width=${width}${resizeProps}/${finalSrc}`;
}

export const CDNImage = component$<CDNImageProps>((props) => {
  const { src, ...rest } = props;
  const finalSrc = getCDNImageUrl(src, rest.width ?? 384);

  return <Image src={import.meta.env.DEV ? src : finalSrc} {...rest} />;
});
